import { useState } from 'react';
import Modal from '@mui/material/Modal';
import { IoCloseOutline as Close } from 'react-icons/io5';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import './ConfirmResolveTicketForm.scss';


export default function ConfirmResolveTicketForm(props) {

    const [cursor] = useState('auto');
    const className = 'confirmResolveTicketForm';

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}
            onKeyPress={(e) => {
                if (e.key === 'Enter') {
                    props?.updateTicketStatus(JSON.parse(props?.adminFieldList?.find((field) => field.title === 'status')?.options)?.find((option) => option.value === 'resolved')?.id);
                }}}>
                <div className={className + '__inner'}>
                    <div className={className + '__inner__titleBar width-wfa flex-row-center-space-between'}>
                        <div className={className + '__inner__titleBar__title flex-row-center-1vw-gap standard-text-semi-large'}>
                            Resolve this ticket?
                        </div>
                        <Close className={className + '__inner__titleBar__close close-button'}
                            onClick={props.closePopup}/>
                    </div>
                    <div className={className + '__inner__form'} >
                        <p>Are you satisfied that this ticket has been resolved?</p>
                        <div className={className + '__inner__buttonFlex'}>
                            <div className={className + '__inner__buttonFlex__submit'}>
                                <BorderBlueButtonV2
                                    text='Resolve'
                                    onClick={() => props?.updateTicketStatus(JSON.parse(props?.adminFieldList?.find((field) => field.title === 'status')?.options)?.find((option) => option.value === 'resolved')?.id)}
                                    disabled={cursor === 'wait'}/>
                            </div>
                             <div className={className + '__inner__buttonFlex__cancel'}>
                                <BorderWhiteButtonV2
                                    text='Cancel'
                                    onClick={props.closePopup}/>
                            </div>
                        </div>
                    </div>
                </div>
        </Modal>
    );
}
